import React from 'react'

import type { ThankYouType } from '../../SendThankYouModal.types'
import * as S from './FooterTabs.styled'

export type ActionButtonProps = {
  tabs: ThankYouType[]
  activeTab: ThankYouType
  onTabChange: (tab: ThankYouType) => void
}

export const FooterTabs = ({ tabs, activeTab, onTabChange }: ActionButtonProps) => {
  return (
    <S.Container>
      {tabs.map((tab) => (
        <S.Tab key={tab} active={tab === activeTab} onClick={() => onTabChange(tab)}>
          {tab}
        </S.Tab>
      ))}
    </S.Container>
  )
}
